"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEKCBOX_DATA_KEYS = exports.CHECKBOX_DATA_HOOKS = void 0;
var CHECKBOX_DATA_HOOKS;
(function (CHECKBOX_DATA_HOOKS) {
    CHECKBOX_DATA_HOOKS["CheckboxWrapper"] = "checkbox-wrapper";
    CHECKBOX_DATA_HOOKS["IconWrapper"] = "icon-wrapper";
    CHECKBOX_DATA_HOOKS["LabelWrapper"] = "label-wrapper";
    CHECKBOX_DATA_HOOKS["CheckboxCore"] = "checkbox-core";
    CHECKBOX_DATA_HOOKS["ErrorIcon"] = "error-icon";
})(CHECKBOX_DATA_HOOKS = exports.CHECKBOX_DATA_HOOKS || (exports.CHECKBOX_DATA_HOOKS = {}));
var CHEKCBOX_DATA_KEYS;
(function (CHEKCBOX_DATA_KEYS) {
    CHEKCBOX_DATA_KEYS["Error"] = "data-error";
    CHEKCBOX_DATA_KEYS["Disabled"] = "data-disabled";
    CHEKCBOX_DATA_KEYS["Checked"] = "data-checked";
    CHEKCBOX_DATA_KEYS["Indeterminate"] = "data-indeterminate";
    CHEKCBOX_DATA_KEYS["Focused"] = "data-focused";
})(CHEKCBOX_DATA_KEYS = exports.CHEKCBOX_DATA_KEYS || (exports.CHEKCBOX_DATA_KEYS = {}));
//# sourceMappingURL=dataHooks.js.map